import pictures from '../../assests/assestimport.js';
const {rp} = pictures;

const road=[
    {
        id:1,
        label:'CONE 1 M',
        band:"KARAM",
        description:`Traffic Cone 1 meter | 1 Mtr - Red - Road Safety - Rubber Base Specifications: Type : Parking Gadgets  
        Multi-purpose, Traffic Cone, for saving your Parking Space, or construction, or Other General Purposes. 
        1 Meter Height 5kg Weight`,
        image:rp[0],
        alt:"Karam Traffic CONE 1 meter height, 5kg weight used for parking space, construction, or other general purposes",
        hscode:'',
    },
    {
        id:2,
        label:'Warning Tape 70mm x 100 yrds',
        band:"KARAM",
        description:`Utra hazard barrier tape. Non adhesive polyethylene barrier tape
        Used for marking off secure areas where caution marks are not suitable
        Diagonal stripe
        Available in 70mm x 100 yrds and differet colors yellow/black, and red/white`,
        image:rp[1],
        alt:"Harzard/Warning Tape 70mm x 100 yrds",
        hscode:'',
    },
    {
        id:3,
        label:'Warning Tape 70mm x 500 METER',
        band:"KARAM",
        description:`Utra hazard barrier tape. Non adhesive polyethylene barrier tape
        Used for marking off secure areas where caution marks are not suitable
        Diagonal stripe
        Available in 70mm x 500mtr and differet colors yellow/black, and red/white`,
        image:rp[2],
        alt:"Harzard/Warning Tape 70mm x 500 meter",
        hscode:'',
    },
]

export default road;